import { TypeMontant } from './TypeMontant';

export class TypeAutresInfosATTR {

  public dateAttribution: string;

  public nbParticipants: number;

  public valeurTotaleEstimee: TypeMontant;

  public nbOffresRecues: number;

  public primeAttribuee: TypeMontant;

  public nbParticipantsEtrangers: number;

  public informations: string;

  constructor() {
    this.dateAttribution = '';
    this.nbParticipants = 0;
    this.valeurTotaleEstimee = new TypeMontant();
    this.nbOffresRecues = null;
    this.primeAttribuee = new TypeMontant();
    this.nbParticipantsEtrangers = 0;
    this.informations = '';

  }
}
